export default {
  strict: true,
  namespaced: true,
  state: {
    flight1: {},
    flight2: {},
    auth1: {},
    auth2: {}
  },
  mutations: {
    setGtagData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/gtag.js